exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6b47a64a] .table-full .v-datatable.v-table>tbody{max-height:calc(100vh - 426px);min-height:calc(100vh - 426px)}", ""]);

// exports
